import React, { useState, useRef, useCallback, useMemo } from "react";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import {
  MenuItem,
  MenuList,
  Grow,
  Paper,
  ClickAwayListener,
  Hidden,
  Popper,
  Divider,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import Button from "../../components/CustomButtons/Button";

// Assets
import styles from "../../assets/jss/material-dashboard-react/components/headerLinksStyle.js";
import defaultUserImage from "../../assets/img/tim_80x80.png"
import logoImage from "../../assets/img/logo.png";
import ProfileSettingsModal from "../../views/Inicio/componentes/perfil";
import { useAuth } from "../../contexts/AuthContext";

const useStyles = makeStyles(styles);

export default function AdminNavbarLinks() {
  const classes = useStyles();
  const history = useHistory();

  const { user } = useAuth();

  const anchorRef = useRef(null);
  const [openProfile, setOpenProfile] = useState(false);
  const [open, setOpen] = useState(false);
  const isWide = useMemo(() => window.innerWidth > 959, []);

  const handleModalClose = () => setOpen(false);

  const userPhoto = useMemo(() => {
    try {
      const userJson = user && JSON.parse(user);
      return userJson?.foto
        ? `${process.env.REACT_APP_SERVER_URL}${user.foto}`
        : defaultUserImage;
    } catch {
      return defaultUserImage;
    }
  }, []);

  const toggleProfileMenu = useCallback((e) => {
    e.stopPropagation();
    setOpenProfile((prev) => !prev);
  }, []);

  const closeProfileMenu = useCallback((event) => {
    if (anchorRef.current?.contains(event.target)) return;
    setOpenProfile(false);
  }, []);

  const handleLogout = useCallback(() => {
    localStorage.clear();
    history.push("/login");
  }, [history]);

  return (
    <div className={classes.manager}>
      <div className={classes.searchWrapper}>
        <img className={classes.image} src={logoImage} alt="logo" />
      </div>

      <Button
        ref={anchorRef}
        color={isWide ? "transparent" : "white"}
        justIcon={isWide}
        simple={!isWide}
        aria-controls={openProfile ? "profile-menu-list-grow" : undefined}
        aria-haspopup="true"
        onClick={toggleProfileMenu}
        className={classes.buttonLink}
      >
        <img src={userPhoto} className={classes.profileImage} alt="Perfil" />
        <Hidden mdUp implementation="css">
          <p className={classes.linkText}>Perfil</p>
        </Hidden>
      </Button>

      <Popper
        open={openProfile}
        anchorEl={anchorRef.current}
        transition
        disablePortal
        placement="bottom-end"
        className={classNames(
          { [classes.popperClose]: !openProfile },
          classes.popperNav
        )}
      >
        {({ TransitionProps }) => (
          <Grow
            {...TransitionProps}
            id="profile-menu-list-grow"
            style={{ transformOrigin: "right top" }}
          >
            <Paper>
              <ClickAwayListener onClickAway={closeProfileMenu}>
                <MenuList role="menu">
                  <MenuItem
                    // onClick={() => history.push("/perfil")}
                    onClick={() => setOpen(true)}
                    className={classes.dropdownItem}
                  >
                    Perfil
                  </MenuItem>
                  <ProfileSettingsModal
                    open={open}
                    onClose={handleModalClose}
                  />
                  <Divider light />
                  <MenuItem
                    onClick={handleLogout}
                    className={classes.dropdownItem}
                  >
                    Cerrar sesión
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
}
